/* global google */
import createSimplePrivateGallery from '@PROJECT_ROOT/assets/desktop/js/search/simplePrivateGallery';
import getAdriaticStyles from '@PROJECT_ROOT/assets/shared/js/map/GoogleMapsStyles';
import loadScript from '@PROJECT_ROOT/assets/shared/js/library/scriptLoader';

const mapElement = document.getElementById('beachGoogleMap');
const mapScriptUrl = mapElement.getAttribute('data-googlemapsapiscripturl');
const beachMapAjaxUrl = mapElement.getAttribute('data-beachmapajaxurl');
const $beachSearchForm = $('#beachSearchForm');
const $pageLoader = $('#pageLoader');
const markers = JSON.parse(mapElement.getAttribute('data-markers'));
const markerInfoUrl = mapElement.getAttribute('data-markerinfourl');
const iconBeach = mapElement.getAttribute('data-beachicon');
const iconBeachActive = mapElement.getAttribute('data-beachactiveicon');
const iconFacility = mapElement.getAttribute('data-facilityicon');
let googleMapsMarkers = [];

$(() => {
    hideOpenMapHeader();

    loadScript(mapScriptUrl).then(() => {
        const mapOptions = getMapOptions();
        const beachMap = new google.maps.Map(mapElement, mapOptions);
        putMarkersToMap(beachMap, markers);

        $beachSearchForm.on('submit', (e) => {
            e.preventDefault();
            $pageLoader.show();
            $.get(beachMapAjaxUrl, $beachSearchForm.serialize())
                .then(
                    (response) => {
                        clearMarkersFromMap();
                        putMarkersToMap(beachMap, response.markers);
                        document.getElementById('backToBeaches').setAttribute('href', response.backToBeachesUrl);

                        if (window.history.replaceState) {
                            window.history.replaceState({}, '', response.contentUrl);
                        }

                        $pageLoader.hide();
                    },
                    () => $pageLoader.hide(),
                );
        });
    });
});

function hideOpenMapHeader() {
    const mapHeader = document.getElementById('mapHeader');
    const openMapHeader = document.getElementById('openMapHeader');

    $('#beachGoogleMap').on('click', () => {
        $(mapHeader).animate({
            top: '-75px',
        }, 300, () => {
            $(mapHeader).addClass('hide');
        });
        $(openMapHeader).removeClass('hide');
    });

    $(openMapHeader).on('click', () => {
        $(mapHeader).removeClass('hide').animate({
            top: '0',
        }, 300);
        $(openMapHeader).addClass('hide');
    });
}

function getMapOptions() {
    return {
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: getAdriaticStyles(),
    };
}

function putMarkersToMap(beachMap, newMarkers) {
    const infoWindow = new google.maps.InfoWindow({ maxWidth: 400 });
    const bounds = new google.maps.LatLngBounds();

    $.each(newMarkers, (id, value) => {
        const markerIcon = getMarkerIcon(value.type);
        const markerPosition = new google.maps.LatLng(value.lat, value.lng);
        bounds.extend(markerPosition);
        const marker = new google.maps.Marker({
            position: markerPosition,
            map: beachMap,
            icon: markerIcon,
            clickable: true,
            title: value.title,
        });

        google.maps.event.addListener(marker, 'click', () => {
            infoWindow.setContent('<div class="loader32w" style="display:block;"></div>');
            infoWindow.open(beachMap, marker);
            const infoUrl = markerInfoUrl.replace('__TYPE__', value.type).replace('__ID__', value.id);

            $.get(infoUrl).done((markerContent) => {
                infoWindow.setContent(`<div class="google-map__scroll-fix">${markerContent}</div>`);

                if (value.type === 'beach') {
                    setUpBeachInfoGallery();
                }

                google.maps.event.addListenerOnce(infoWindow, 'domready', () => {
                    const clickAwayListener = beachMap.addListener('click', () => {
                        infoWindow.close();
                        clickAwayListener.remove();
                    });
                });
            });
        });

        googleMapsMarkers.push(marker);
    });

    beachMap.fitBounds(bounds); // auto-zoom
    beachMap.panToBounds(bounds); // auto-center
}

function getMarkerIcon(markerType) {
    if (markerType === 'beach') {
        return iconBeach;
    }

    if (markerType === 'beachActive') {
        return iconBeachActive;
    }

    if (markerType === 'facility') {
        return iconFacility;
    }

    return null;
}

function clearMarkersFromMap() {
    for (let i = 0; i < googleMapsMarkers.length; i += 1) {
        googleMapsMarkers[i].setMap(null);
    }
    googleMapsMarkers = [];
}

function setUpBeachInfoGallery() {
    $('.beachInfoSimpleGallery').toArray().forEach((galleryElement) => {
        const $galleryContainer = $(galleryElement);
        createSimplePrivateGallery({
            source: $galleryContainer.data('source').map((image) => ({ url: image.standard })),
            nextButton: $galleryContainer.find('.simpleGalleryNext')[0],
            previousButton: $galleryContainer.find('.simpleGalleryPrev')[0],
            counterElement: $galleryContainer.find('.simpleGalleryCounter')[0],
            imageElement: $galleryContainer.find('.currentImage img')[0],
        });
    });
}
